import { RemoteProgramRules } from '../../../data/usecases/program-rules/program-rules'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory-no-redirect'

export const makeProgramRules = (ano?: number | null):any => new RemoteProgramRules(`/regrasprograma${ano ? `/${ano}` : ''}`, makeAxiosHttpClient())

export const makeVerifyAcceptProgramRules = ():any => new RemoteProgramRules('/regulamento/check-term', makeAxiosHttpClient())

export const makeAcceptProgramRules = ():any => new RemoteProgramRules('/regulamento/accept-term', makeAxiosHttpClient())

export const makeRegulamentoExport = ():any => new RemoteProgramRules('/regulamento/export', makeAxiosHttpClient())
